module.exports = __webpack_public_path__ + "static/media/Ellipse.a744c699.png";